import Modal, { IconBlock, MessageBlock, ActionBlock } from '@components/Modal';

interface PrintModalProps {
  messages: string[];
  onPrint: () => void;
  onClose: () => void;
}

export const PrintPromptModal = ({ messages, onClose, onPrint }: PrintModalProps) => {
  return (
    <Modal minWidth="42rem">
      <IconBlock icon="printIcon" />
      <MessageBlock messages={messages} />
      <ActionBlock
        actions={[
          {
            appearance: 'secondary',
            text: 'Cancel',
            onClick: onClose,
          },
          {
            appearance: 'primary',
            text: 'Print',
            onClick: onPrint,
          },
        ]}
      />
    </Modal>
  );
};
